// Bilingual translations: Hungarian (default) + English
export const translations = {
  hu: {
    nav: {
      services: "Szolgáltatás",
      about: "Rólunk",
      process: "Folyamat",
      booking: "Foglalás",
      contact: "Kapcsolat",
      bookNow: "Online foglalás",
    },
    hero: {
      eyebrow: "Balatonszemes · Klímatisztító Szakszerviz",
      titleA: "Tisztább",
      titleB: "levegő",
      titleC: "a Balaton partján.",
      subtitle:
        "Nemcsak port törlünk: nagynyomású mosóval és professzionális vegyszerekkel teljesen fertőtlenítjük a klímádat, hogy tiszta, egészséges levegőt lélegezz be a balatoni nyárban. Időpontot pedig online foglalsz, két perc alatt.",
      ctaPrimary: "Online időpontfoglalás",
      ctaSecondary: "Hívj minket",
      cardTitle: "Profi mélytisztítás",
      cardSub: "60–90 perc / készülék",
      stats: [
        { value: "100%", label: "Helyi csapat" },
        { value: "24ó", label: "Visszahívási idő" },
        { value: "5★", label: "Ügyfél elégedettség" },
      ],
    },
    services: {
      label: "Szolgáltatás",
      title: "Mit kapsz egy teljes klímatisztításnál?",
      subtitle:
        "Nem csak áttöröljük: szétszedjük, kimossuk, fertőtlenítjük. A klímád úgy fog hűteni, mint új korában.",
      items: [
        {
          title: "Szűrőmosás és fertőtlenítés",
          body: "Kivesszük a szűrőket, alaposan kimossuk, majd antibakteriális szerrel kezeljük – itt gyűlik a por és a pollen java.",
        },
        {
          title: "Hőcserélő mélytisztítás",
          body: "Habosító vegyszerrel és nagynyomású mosással szedjük le a rárakódott koszt. Érezhetően jobban hűt, kevesebbet fogyaszt.",
        },
        {
          title: "Gombátlanítás és szagsemlegesítés",
          body: "A dohos szag a klímában megtelepedett gombáktól jön. Ózonos és gombaölő kezeléssel az okát szüntetjük meg, nem csak elfedjük.",
        },
        {
          title: "Kültéri egység átvizsgálása",
          body: "Lemossuk a kondenzátort, átnézzük a csatlakozásokat és a cseppvíz-elvezetést – hogy kint is minden rendben legyen.",
        },
        {
          title: "Teljesítmény teszt",
          body: "A végén megmérjük a befújt levegő hőmérsékletét, a zajt és a fogyasztást – feketén-fehéren látod, mennyit javult.",
        },
      ],
    },
    about: {
      label: "Rólunk",
      title: "Helyi csapat. Egyetlen küldetés.",
      body1:
        "Az A-team egy balatonszemesi kisvállalkozás, és egy dologhoz értünk igazán: a klímatisztításhoz. Nem szerelünk, nem javítunk – tisztítunk, alaposan, minden egyes alkalommal.",
      body2:
        "Itt élünk a tóparton, így pontosan tudjuk, mit művel a klímákkal a nyári por, a pára és a pollen. Évi egy tisztítással mindez megelőzhető – a klímád hálás lesz érte, a villanyszámlád úgyszintén.",
      bullets: [
        "Saját, professzionális eszközpark",
        "Munka után írásos dokumentáció és garancia",
        "Beszélünk magyarul, angolul, németül és hollandul",
      ],
      locationCaption: "déli part · Magyarország",
    },
    process: {
      label: "Folyamat",
      title: "Három lépés, és kész",
      steps: [
        {
          n: "01",
          title: "Foglalj online",
          body: "Válaszd ki a napot, add meg a klíma típusát és a darabszámot – az egész két perc.",
        },
        {
          n: "02",
          title: "Visszahívunk",
          body: "24 órán belül hívunk, és egyeztetjük a pontos időpontot meg a részleteket.",
        },
        {
          n: "03",
          title: "Jövünk és tisztítunk",
          body: "Készülékenként 60–90 perc, és már élvezheted is a friss, tiszta levegőt.",
        },
      ],
    },
    booking: {
      label: "Foglalás",
      title: "Foglalj időpontot online",
      subtitle:
        "Töltsd ki az űrlapot két perc alatt – 24 órán belül visszahívunk, és mindent egyeztetünk.",
      step: "Lépés",
      of: "/",
      next: "Tovább",
      back: "Vissza",
      submit: "Foglalás elküldése",
      submitting: "Küldés…",
      fields: {
        name: "Teljes név",
        phone: "Telefonszám",
        email: "Email cím",
        address: "Cím (utca, házszám, település)",
        acType: "Klíma típusa",
        units: "Készülékek száma",
        date: "Választott dátum",
        time: "Időpont (napszak)",
        notes: "Megjegyzés (opcionális)",
        notesPh: "Pl. hány szobában van klíma, kutya a kertben, parkolás…",
      },
      acTypes: {
        split: "Split (1 beltéri)",
        multi_split: "Multi-split (több beltéri)",
        cassette: "Kazettás / mennyezeti",
        portable: "Mobil klíma",
        other: "Egyéb",
      },
      times: {
        morning: "Reggel (8–11)",
        midday: "Délelőtt (11–14)",
        afternoon: "Délután (14–17)",
        evening: "Este (17–20)",
      },
      steps: {
        s1: "Kapcsolat",
        s2: "Helyszín és klíma",
        s3: "Időpont",
      },
      success: {
        title: "Köszönjük a foglalást!",
        body: "Megkaptuk a foglalásod – 24 órán belül hívunk a megerősítéshez. Addig is dőlj hátra!",
        ref: "Foglalási azonosító",
        cta: "Új foglalás",
      },
      errors: {
        required: "Ezt a mezőt kérjük, töltsd ki",
        email: "Ez az e-mail cím nem tűnik érvényesnek",
        phone: "Adj meg egy érvényes telefonszámot",
        server: "Hoppá, valami hiba történt. Próbáld újra!",
        consent: "A foglaláshoz kérjük, pipáld ki a tudnivalót.",
      },
      consentLabel:
        "Tudomásul veszem, hogy a klímatisztítás nem javítás: meglévő mechanikai vagy elektronikai hiba esetén a tisztítás nem végezhető el.",
      terms: {
        pre: "Elfogadom az ",
        aszfLink: "Általános Szerződési Feltételeket",
        mid: " és az ",
        gdprLink: "Adatvédelmi tájékoztatót",
        post: ".",
        error: "A foglaláshoz kérjük, fogadd el az ÁSZF-et és az Adatvédelmi tájékoztatót.",
      },
    },
    contact: {
      label: "Kapcsolat",
      title: "Beszéljünk – könnyebb, mint gondolnád",
      phone: "Telefon",
      email: "Email",
      area: "Szolgáltatási terület",
      areaValue: "Balatonszemes és 25 km-es körzete",
      hours: "Nyitvatartás",
      hoursValue: "H–Szo: 8:00 – 19:00",
    },
    footer: {
      tag: "Klímatisztítás Balatonszemesen és a déli parton. Online időpontfoglalás.",
      rights: "Minden jog fenntartva.",
      built: "Helyi csapattal készült a Balaton partján.",
    },
    marquee: [
      "Egészségesebb levegő",
      "Online időpontfoglalás",
      "Alacsonyabb áramfogyasztás",
      "Hosszabb élettartam",
      "Allergénmentes otthon",
      "Friss, szagtalan levegő",
    ],
    review: {
      label: "Vélemények",
      title: "Elégedett vagy? Mondd el a Google-on!",
      body: "Egy 30 másodperces értékelés hatalmas segítség egy helyi kisvállalkozásnak. Köszönjük, ha időt szánsz rá!",
      cta: "Értékelés a Google-on",
      subnote: "Új ablakban nyílik · a Google fiókoddal léphetsz be",
    },
    showcase: {
      title: "Nézd meg, hogyan dolgozunk",
      subtitle: "22 másodperc élesben – így néz ki nálunk egy klímatisztítás.",
      play: "Lejátszás",
      duration: "22 másodperc · hanggal",
      noSupport: "A böngésződ nem támogatja a videó lejátszását.",
    },
    testimonials: {
      title: "Amit az ügyfeleink mondanak",
    },
    whatsapp: {
      label: "WhatsApp",
      title: "Írj nekünk WhatsAppon",
      value: "Gyorsan válaszolunk – fotót is küldhetsz a klímádról",
      cta: "Írj nekünk",
      floating: "Üzenet",
      prefilled:
        "Üdvözlöm! Klímatisztítás iránt érdeklődöm Balatonszemesen. Tudna nekem időpontot adni?",
    },
    notice: {
      label: "Fontos tudnivaló",
      title: "A tisztítás nem javítás",
      greeting: "Tisztelt Ügyfelünk!",
      p1: "Szeretnénk felhívni a figyelmét a karbantartás és a javítás közötti alapvető különbségre. A klímatisztítás célja a lerakódott por, gombák és baktériumok eltávolítása, a higiénikus működés és az energiahatékonyság biztosítása.",
      p2: "A tisztítás során nem történik alkatrészcsere, gáztöltés vagy elektromos javítás. Ha a klímaberendezésnek meglévő mechanikai vagy elektronikai hibája van (pl. panelhiba, kompresszorhiba, hűtőközeg-szivárgás), a tisztítás után is hibás marad.",
      p3: "Kollégáink a munka megkezdése előtt minden esetben elindítják és ellenőrzik a készüléket. Amennyiben a klíma már az indításkor hibajelenséget produkál, a tisztítást a hiba elhárításáig nem áll módunkban elvégezni.",
    },
    calculator: {
      label: "Árkalkulátor",
      title: "Számold ki, mennyibe kerül",
      subtitle: "Állítsd be a készülékek számát, és azonnal látod a pontos árat – nincs rejtett költség.",
      indoor: "Beltéri egységek",
      indoorHint: "Az első 21 000 Ft, a többi 15 000 Ft/db",
      outdoor: "Kültéri egységek",
      outdoorHint: "4 000 Ft/db",
      high: "Ebből 3 m-nél magasabban van",
      highHint: "6 500 Ft/db a 4 000 Ft helyett",
      far: "Balatonszemestől 15 km-nél távolabb vagyok",
      farHint: "+5 000 Ft kiszállási díj",
      breakdown: {
        firstIndoor: "Első beltéri egység",
        extraIndoor: "További beltéri egység",
        outdoorStd: "Kültéri egység",
        outdoorHigh: "Kültéri egység (3 m felett)",
        travel: "Kiszállási díj (15 km felett)",
      },
      total: "Összesen",
      cta: "Időpontot foglalok ennyiért",
      prefillNote: "Árkalkulátorból: {indoor} beltéri, {outdoor} kültéri egység – kalkulált ár: {total}",
      note: "Az ár tartalmazza a teljes mélytisztítást, a fertőtlenítést és a teljesítmény tesztet.",
      gate: {
        title: "Egy lépés az árkalkulátorig",
        subtitle: "Add meg az e-mail címed vagy a telefonszámod, és máris számolhatsz. Csak akkor keresünk, ha te is szeretnéd.",
        name: "Név (opcionális)",
        email: "E-mail cím",
        phone: "Telefonszám",
        or: "vagy",
        cta: "Kalkulátor megnyitása",
        error: "Adj meg legalább egy elérhetőséget (e-mail vagy telefon).",
        emailError: "Ez az e-mail cím nem tűnik érvényesnek.",
      },
      fancoil: {
        label: "Fan coil vagy mennyezeti klímád van?",
        body: "Speciális szerelést igényel, ezért egyedi árajánlatot készítünk rá.",
        cta: "Egyedi ajánlatot kérek",
        page: {
          title: "Fan coil és mennyezeti klíma – egyedi árajánlat",
          lead: "A fan coil és a mennyezeti (kazettás) berendezések tisztítása speciális szerelést és bontást igényel, ezért ezekre nem tudunk listaárat adni – minden esetben egyedi árajánlatot készítünk.",
          points: [
            "A burkolat és a cseppvíztálca bontása típusonként eltérő",
            "Gyakran létrás vagy állványos munka szükséges",
            "Az ár a beépítés helyétől és a hozzáférhetőségtől függ",
          ],
          how: "Kérj ajánlatot – ha tudsz, küldj egy fotót a készülékről, és 24 órán belül pontos árat mondunk:",
          callCta: "Hívás",
          waCta: "Ajánlatkérés WhatsAppon",
          emailCta: "E-mail küldése",
          waMsg: "Üdvözlöm! Fan coil / mennyezeti klíma tisztítására szeretnék egyedi árajánlatot kérni.",
          back: "Vissza a főoldalra",
        },
      },
    },
    faq: {
      label: "GYIK",
      title: "Gyakori kérdések",
      items: [
        { q: "Mennyibe kerül a klímatisztítás?", a: "Az első beltéri egység 21 000 Ft, minden további készülékre jelentős kedvezményt adunk. Pontos árat az online árkalkulátorunkkal számolhatsz pár kattintással." },
        { q: "Milyen gyakran kell klímát tisztíttatni?", a: "Évente legalább egyszer, ideálisan a nyári szezon előtt. A tóparti por, pára és pollen miatt a Balatonnál ez különösen fontos az egészséges levegőhöz és az alacsony fogyasztáshoz." },
        { q: "Mennyi ideig tart a tisztítás?", a: "Készülékenként általában 60–90 perc. A munka végén teljesítmény tesztet is végzünk, így feketén-fehéren látod az eredményt." },
        { q: "Hol vállaltok klímatisztítást?", a: "Balatonszemesen és a Balaton déli partján: Siófok, Balatonföldvár, Balatonszárszó, Balatonlelle, Balatonboglár, Fonyód és környékük. 15 km-en túl 5 000 Ft kiszállási díjat számítunk fel." },
        { q: "Miért dohos, kellemetlen szagú a klíma levegője?", a: "A hőcserélőn megtelepedett gombák és baktériumok okozzák. Ózonos és gombaölő kezeléssel az okát szüntetjük meg, nem csak elfedjük a szagot." },
      ],
    },
  },
  en: {
    nav: {
      services: "Service",
      about: "About",
      process: "Process",
      booking: "Booking",
      contact: "Contact",
      bookNow: "Book now",
    },
    hero: {
      eyebrow: "Balatonszemes · Specialist AC Cleaning",
      titleA: "Fresher",
      titleB: "air",
      titleC: "by Lake Balaton.",
      subtitle:
        "A-team provides professional air conditioner cleaning for homes and holiday houses in and around Balatonszemes. Healthier air, more efficient cooling, longer equipment life.",
      ctaPrimary: "Book an appointment",
      ctaSecondary: "Call us now",
      cardTitle: "Professional cleaning",
      cardSub: "60–90 min / unit",
      stats: [
        { value: "100%", label: "Local team" },
        { value: "24h", label: "Callback time" },
        { value: "5★", label: "Customer rating" },
      ],
    },
    services: {
      label: "Service",
      title: "What a real AC cleaning looks like",
      subtitle:
        "More than dusting. A thorough deep-clean process that restores your AC's original performance.",
      items: [
        {
          title: "Filter wash & sanitisation",
          body: "We remove, wash and treat the filters with an anti-bacterial solution.",
        },
        {
          title: "Heat exchanger deep clean",
          body: "Foam technology removes buildup so the unit cools efficiently again.",
        },
        {
          title: "Fungal & odour treatment",
          body: "Ozone and anti-fungal treatment against unpleasant smells and mould spores.",
        },
        {
          title: "Outdoor unit check",
          body: "Condenser wash, inspection of connections and condensate drainage.",
        },
        {
          title: "Performance test",
          body: "We measure inlet/outlet temperature, noise and power consumption.",
        },
      ],
    },
    about: {
      label: "About",
      title: "A local team. One mission.",
      body1:
        "A-team is a small business based in Balatonszemes, focused on one thing: cleaning air conditioners. We don't install or repair – we clean, thoroughly, every time.",
      body2:
        "We know the lakeside environment: summer dust, humidity, pollen and lake-shore conditions together reduce AC performance. A yearly cleaning solves it.",
      bullets: [
        "Professional equipment of our own",
        "Documentation & guarantee after the job",
        "Customer service in Hungarian, English, German & Dutch",
      ],
      locationCaption: "south shore · Hungary",
    },
    process: {
      label: "Process",
      title: "Three simple steps",
      steps: [
        {
          n: "01",
          title: "Book online",
          body: "Choose a date, AC type and number of units – a few clicks.",
        },
        {
          n: "02",
          title: "Phone confirmation",
          body: "We call you back within 24 hours to finalise the details.",
        },
        {
          n: "03",
          title: "On-site cleaning",
          body: "Usually 60–90 minutes per unit. Fresh air, efficient cooling.",
        },
      ],
    },
    booking: {
      label: "Booking",
      title: "Book your appointment",
      subtitle:
        "Fill in the form. We'll call you back within 24 hours to confirm.",
      step: "Step",
      of: "of",
      next: "Next",
      back: "Back",
      submit: "Send booking",
      submitting: "Sending…",
      fields: {
        name: "Full name",
        phone: "Phone",
        email: "Email",
        address: "Address (street, number, town)",
        acType: "AC type",
        units: "Number of units",
        date: "Preferred date",
        time: "Time of day",
        notes: "Notes (optional)",
        notesPh: "E.g. which rooms have an AC, parking, gate access…",
      },
      acTypes: {
        split: "Split (1 indoor)",
        multi_split: "Multi-split (multiple indoor)",
        cassette: "Cassette / ceiling",
        portable: "Portable AC",
        other: "Other",
      },
      times: {
        morning: "Morning (8–11)",
        midday: "Midday (11–14)",
        afternoon: "Afternoon (14–17)",
        evening: "Evening (17–20)",
      },
      steps: {
        s1: "Contact",
        s2: "Location & AC",
        s3: "Date & time",
      },
      success: {
        title: "Thank you for booking!",
        body: "Your booking has been received. We'll call you within 24 hours to confirm.",
        ref: "Booking reference",
        cta: "New booking",
      },
      errors: {
        required: "Required field",
        email: "Invalid email",
        phone: "Please enter a valid phone number",
        server: "Something went wrong. Please try again.",
        consent: "Please accept the notice to complete your booking.",
      },
      consentLabel:
        "I acknowledge that AC cleaning is not a repair: in case of an existing mechanical or electronic fault, the cleaning cannot be carried out.",
      terms: {
        pre: "I accept the ",
        aszfLink: "Terms & Conditions",
        mid: " and the ",
        gdprLink: "Privacy Policy",
        post: ".",
        error: "Please accept the Terms & Conditions and the Privacy Policy to complete your booking.",
      },
    },
    contact: {
      label: "Contact",
      title: "Let's talk – it's easier than you think",
      phone: "Phone",
      email: "Email",
      area: "Service area",
      areaValue: "Balatonszemes and 25 km around",
      hours: "Opening hours",
      hoursValue: "Mon–Sat: 8:00 – 19:00",
    },
    footer: {
      tag: "AC cleaning in Balatonszemes",
      rights: "All rights reserved.",
      built: "Built by a local team on the shore of Lake Balaton.",
    },
    marquee: [
      "Healthier air",
      "Lower power use",
      "Longer lifespan",
      "Allergen-free home",
      "Odour-free air",
    ],
    review: {
      label: "Reviews",
      title: "Happy with us? Tell Google!",
      body: "A 30-second review is a huge help for a small local business. Thank you for taking the time!",
      cta: "Review us on Google",
      subnote: "Opens in a new tab · sign in with your Google account",
    },
    showcase: {
      title: "See how we work",
      subtitle: "A short behind-the-scenes look at our AC cleaning process – live.",
      play: "Play video",
      duration: "22 seconds · with sound",
      noSupport: "Your browser does not support video playback.",
    },
    testimonials: {
      title: "What our customers say",
    },
    whatsapp: {
      label: "WhatsApp",
      title: "Message us on WhatsApp",
      value: "Quick reply, photos welcome",
      cta: "Send us a message",
      floating: "Chat",
      prefilled:
        "Hello! I'm interested in AC cleaning in Balatonszemes. Could you give me a date?",
    },
    notice: {
      label: "Important notice",
      title: "Cleaning is not repair",
      greeting: "Dear Customer,",
      p1: "We would like to draw your attention to the fundamental difference between maintenance and repair. The purpose of AC cleaning is to remove accumulated dust, fungi and bacteria, ensuring hygienic operation and energy efficiency.",
      p2: "Cleaning does not include the replacement of parts, refrigerant refilling or electrical repairs. If your air conditioner has an existing mechanical or electronic fault (e.g. board failure, compressor failure, refrigerant leak), it will remain faulty after cleaning as well.",
      p3: "Before starting the work, our colleagues always switch on and check the unit. If the AC shows a fault at start-up, we are unable to carry out the cleaning until the fault has been repaired.",
    },
    calculator: {
      label: "Price calculator",
      title: "See exactly what it costs",
      subtitle: "Set the number of units and get the exact price instantly – no hidden fees.",
      indoor: "Indoor units",
      indoorHint: "First unit 21,000 Ft, each additional 15,000 Ft",
      outdoor: "Outdoor units",
      outdoorHint: "4,000 Ft each",
      high: "Of which mounted above 3 m",
      highHint: "6,500 Ft each instead of 4,000 Ft",
      far: "I'm more than 15 km from Balatonszemes",
      farHint: "+5,000 Ft travel fee",
      breakdown: {
        firstIndoor: "First indoor unit",
        extraIndoor: "Additional indoor unit",
        outdoorStd: "Outdoor unit",
        outdoorHigh: "Outdoor unit (above 3 m)",
        travel: "Travel fee (over 15 km)",
      },
      total: "Total",
      cta: "Book at this price",
      prefillNote: "From the price calculator: {indoor} indoor, {outdoor} outdoor unit(s) – calculated price: {total}",
      note: "The price includes full deep cleaning, disinfection and the performance test.",
      gate: {
        title: "One step to the calculator",
        subtitle: "Enter your email or phone number and start calculating. We'll only contact you if you want us to.",
        name: "Name (optional)",
        email: "Email address",
        phone: "Phone number",
        or: "or",
        cta: "Open the calculator",
        error: "Please provide at least one contact (email or phone).",
        emailError: "This email address doesn't look valid.",
      },
      fancoil: {
        label: "Do you have a fan coil or ceiling unit?",
        body: "It requires special disassembly, so we prepare an individual quote.",
        cta: "Request a custom quote",
        page: {
          title: "Fan coil & ceiling units – custom quote",
          lead: "Cleaning fan coil and ceiling (cassette) units requires special disassembly, so we cannot offer a list price – we always prepare an individual quote.",
          points: [
            "Removing the casing and drain tray differs by model",
            "Ladder or scaffold work is often required",
            "The price depends on the location and accessibility of the unit",
          ],
          how: "Request a quote – if you can, send a photo of the unit and we'll give you an exact price within 24 hours:",
          callCta: "Call us",
          waCta: "Request via WhatsApp",
          emailCta: "Send an email",
          waMsg: "Hello! I'd like to request a custom quote for cleaning a fan coil / ceiling AC unit.",
          back: "Back to the homepage",
        },
      },
    },
    faq: {
      label: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "How much does AC cleaning cost?", a: "First indoor unit 21,000 Ft — significant discount on each additional unit. Get your exact price with our online calculator." },
        { q: "How often should an AC be cleaned?", a: "At least once a year, ideally before summer. Lakeside dust, humidity and pollen make it especially important at Lake Balaton." },
        { q: "How long does the cleaning take?", a: "Usually 60–90 minutes per unit, finished with a performance test." },
        { q: "Which areas do you cover?", a: "Balatonszemes and the southern shore of Lake Balaton: Siófok, Balatonföldvár, Balatonszárszó, Balatonlelle, Balatonboglár, Fonyód and surroundings. Over 15 km a 5,000 Ft travel fee applies." },
        { q: "Why does my AC smell musty?", a: "Fungi and bacteria on the heat exchanger cause it. Our ozone and antifungal treatment removes the cause, not just the smell." },
      ],
    },
  },
  de: {
    nav: {
      services: "Leistung",
      about: "Über uns",
      process: "Ablauf",
      booking: "Terminbuchung",
      contact: "Kontakt",
      bookNow: "Termin buchen",
    },
    hero: {
      eyebrow: "Balatonszemes · Klimaanlagen-Reinigung",
      titleA: "Frischere",
      titleB: "Luft",
      titleC: "am Plattensee.",
      subtitle:
        "A-team bietet professionelle Klimaanlagen-Reinigung für Häuser und Ferienhäuser in und um Balatonszemes. Gesündere Luft, effizientere Kühlung, längere Lebensdauer Ihres Geräts.",
      ctaPrimary: "Termin vereinbaren",
      ctaSecondary: "Jetzt anrufen",
      cardTitle: "Professionelle Reinigung",
      cardSub: "60–90 Min. / Gerät",
      stats: [
        { value: "100%", label: "Lokales Team" },
        { value: "24h", label: "Rückrufzeit" },
        { value: "5★", label: "Kundenbewertung" },
      ],
    },
    services: {
      label: "Leistung",
      title: "So sieht eine echte Klimareinigung aus",
      subtitle:
        "Mehr als nur Staub wischen. Ein gründlicher Tiefenreinigungsprozess, der die ursprüngliche Leistung Ihrer Klimaanlage wiederherstellt.",
      items: [
        {
          title: "Filterwäsche & Desinfektion",
          body: "Wir entnehmen, waschen und behandeln die Filter mit einer antibakteriellen Lösung.",
        },
        {
          title: "Wärmetauscher-Tiefenreinigung",
          body: "Schaumtechnologie löst Ablagerungen – das Gerät kühlt wieder effizient.",
        },
        {
          title: "Schimmel- & Geruchsbehandlung",
          body: "Ozon- und Antipilz-Behandlung gegen unangenehme Gerüche und Schimmelsporen.",
        },
        {
          title: "Außengerät-Prüfung",
          body: "Reinigung des Kondensators, Prüfung der Anschlüsse und des Kondensatablaufs.",
        },
        {
          title: "Leistungstest",
          body: "Wir messen Ein-/Austrittstemperatur, Geräuschpegel und Stromverbrauch.",
        },
      ],
    },
    about: {
      label: "Über uns",
      title: "Ein lokales Team. Eine Mission.",
      body1:
        "A-team ist ein Kleinunternehmen mit Sitz in Balatonszemes, das sich auf eine einzige Sache konzentriert: die Reinigung von Klimaanlagen. Wir installieren oder reparieren nicht – wir reinigen, gründlich, jedes Mal.",
      body2:
        "Wir kennen die Umgebung am See: Sommerhitze, Luftfeuchtigkeit, Pollen und die Bedingungen am Ufer mindern zusammen die Leistung der Klimaanlagen. Eine jährliche Reinigung löst das.",
      bullets: [
        "Eigene, professionelle Ausrüstung",
        "Dokumentation & Garantie nach jeder Reinigung",
        "Kundenservice auf Ungarisch, Englisch, Deutsch & Niederländisch",
      ],
      locationCaption: "Südufer · Ungarn",
    },
    process: {
      label: "Ablauf",
      title: "Drei einfache Schritte",
      steps: [
        {
          n: "01",
          title: "Online buchen",
          body: "Wählen Sie Datum, Gerätetyp und Stückzahl – nur ein paar Klicks.",
        },
        {
          n: "02",
          title: "Telefonische Bestätigung",
          body: "Wir rufen Sie innerhalb von 24 Stunden zurück, um die Details zu bestätigen.",
        },
        {
          n: "03",
          title: "Reinigung vor Ort",
          body: "In der Regel 60–90 Minuten pro Gerät. Frische Luft, effiziente Kühlung.",
        },
      ],
    },
    booking: {
      label: "Terminbuchung",
      title: "Vereinbaren Sie Ihren Termin",
      subtitle:
        "Füllen Sie das Formular aus. Wir rufen Sie innerhalb von 24 Stunden zur Bestätigung zurück.",
      step: "Schritt",
      of: "von",
      next: "Weiter",
      back: "Zurück",
      submit: "Buchung absenden",
      submitting: "Senden…",
      fields: {
        name: "Vollständiger Name",
        phone: "Telefon",
        email: "E-Mail",
        address: "Adresse (Straße, Nr., Ort)",
        acType: "Gerätetyp",
        units: "Anzahl der Geräte",
        date: "Wunschtermin",
        time: "Tageszeit",
        notes: "Anmerkungen (optional)",
        notesPh: "Z.B. in welchen Räumen Klima ist, Parkmöglichkeit, Toreinfahrt…",
      },
      acTypes: {
        split: "Split (1 Innengerät)",
        multi_split: "Multi-Split (mehrere Innengeräte)",
        cassette: "Kassette / Decke",
        portable: "Mobile Klimaanlage",
        other: "Sonstiges",
      },
      times: {
        morning: "Vormittag (8–11)",
        midday: "Mittag (11–14)",
        afternoon: "Nachmittag (14–17)",
        evening: "Abend (17–20)",
      },
      steps: {
        s1: "Kontakt",
        s2: "Ort & Gerät",
        s3: "Datum & Zeit",
      },
      success: {
        title: "Vielen Dank für Ihre Buchung!",
        body: "Ihre Buchung ist eingegangen. Wir rufen Sie innerhalb von 24 Stunden zur Bestätigung zurück.",
        ref: "Buchungsnummer",
        cta: "Neue Buchung",
      },
      errors: {
        required: "Pflichtfeld",
        email: "Ungültige E-Mail-Adresse",
        phone: "Bitte geben Sie eine gültige Telefonnummer ein",
        server: "Beim Senden ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        consent: "Bitte bestätigen Sie den Hinweis, um die Buchung abzuschließen.",
      },
      consentLabel:
        "Ich nehme zur Kenntnis, dass die Klimareinigung keine Reparatur ist: bei einem bestehenden mechanischen oder elektronischen Defekt kann die Reinigung nicht durchgeführt werden.",
      terms: {
        pre: "Ich akzeptiere die ",
        aszfLink: "Allgemeinen Geschäftsbedingungen",
        mid: " und die ",
        gdprLink: "Datenschutzerklärung",
        post: ".",
        error: "Bitte akzeptieren Sie die AGB und die Datenschutzerklärung, um die Buchung abzuschließen.",
      },
    },
    contact: {
      label: "Kontakt",
      title: "Sprechen wir – einfacher als Sie denken",
      phone: "Telefon",
      email: "E-Mail",
      area: "Servicegebiet",
      areaValue: "Balatonszemes und Umkreis von 25 km",
      hours: "Öffnungszeiten",
      hoursValue: "Mo–Sa: 8:00 – 19:00",
    },
    footer: {
      tag: "Klimaanlagen-Reinigung in Balatonszemes",
      rights: "Alle Rechte vorbehalten.",
      built: "Erstellt von einem lokalen Team am Ufer des Plattensees.",
    },
    marquee: [
      "Gesündere Luft",
      "Geringerer Stromverbrauch",
      "Längere Lebensdauer",
      "Allergenfreies Zuhause",
      "Geruchsfreie Luft",
    ],
    review: {
      label: "Bewertungen",
      title: "Zufrieden? Sagen Sie es bei Google!",
      body: "Eine 30-Sekunden-Bewertung hilft einem lokalen Kleinunternehmen enorm. Vielen Dank, dass Sie sich die Zeit nehmen!",
      cta: "Bei Google bewerten",
      subnote: "Wird in einem neuen Tab geöffnet · mit Ihrem Google-Konto anmelden",
    },
    showcase: {
      title: "So arbeiten wir",
      subtitle: "Ein kurzer Einblick in unseren Klimareinigungsprozess – live.",
      play: "Video abspielen",
      duration: "22 Sekunden · mit Ton",
      noSupport: "Ihr Browser unterstützt die Videowiedergabe nicht.",
    },
    testimonials: {
      title: "Was unsere Kunden sagen",
    },
    whatsapp: {
      label: "WhatsApp",
      title: "Schreiben Sie uns auf WhatsApp",
      value: "Schnelle Antwort, Fotos willkommen",
      cta: "Nachricht senden",
      floating: "Chat",
      prefilled:
        "Hallo! Ich interessiere mich für eine Klimaanlagen-Reinigung in Balatonszemes. Können Sie mir einen Termin geben?",
    },
    notice: {
      label: "Wichtiger Hinweis",
      title: "Reinigung ist keine Reparatur",
      greeting: "Sehr geehrte Kundin, sehr geehrter Kunde,",
      p1: "wir möchten Sie auf den grundlegenden Unterschied zwischen Wartung und Reparatur hinweisen. Ziel der Klimareinigung ist die Entfernung von abgelagertem Staub, Pilzen und Bakterien sowie die Sicherstellung eines hygienischen Betriebs und der Energieeffizienz.",
      p2: "Bei der Reinigung erfolgt kein Austausch von Bauteilen, keine Kältemittelbefüllung und keine elektrische Reparatur. Wenn Ihr Klimagerät einen bestehenden mechanischen oder elektronischen Defekt hat (z. B. Platinenfehler, Kompressorschaden, Kältemittelleck), bleibt es auch nach der Reinigung defekt.",
      p3: "Unsere Kollegen schalten das Gerät vor Arbeitsbeginn in jedem Fall ein und überprüfen es. Zeigt die Klimaanlage bereits beim Einschalten eine Störung, können wir die Reinigung erst nach Behebung des Defekts durchführen.",
    },
    calculator: {
      label: "Preisrechner",
      title: "Berechnen Sie Ihren Preis",
      subtitle: "Stellen Sie die Anzahl der Geräte ein und sehen Sie sofort den genauen Preis – ohne versteckte Kosten.",
      indoor: "Innengeräte",
      indoorHint: "Erstes Gerät 21.000 Ft, jedes weitere 15.000 Ft",
      outdoor: "Außengeräte",
      outdoorHint: "4.000 Ft pro Stück",
      high: "Davon über 3 m montiert",
      highHint: "6.500 Ft statt 4.000 Ft",
      far: "Ich bin mehr als 15 km von Balatonszemes entfernt",
      farHint: "+5.000 Ft Anfahrtskosten",
      breakdown: {
        firstIndoor: "Erstes Innengerät",
        extraIndoor: "Weiteres Innengerät",
        outdoorStd: "Außengerät",
        outdoorHigh: "Außengerät (über 3 m)",
        travel: "Anfahrt (über 15 km)",
      },
      total: "Gesamt",
      cta: "Zu diesem Preis buchen",
      prefillNote: "Aus dem Preisrechner: {indoor} Innengerät(e), {outdoor} Außengerät(e) – berechneter Preis: {total}",
      note: "Der Preis beinhaltet die komplette Tiefenreinigung, Desinfektion und den Leistungstest.",
      gate: {
        title: "Ein Schritt zum Preisrechner",
        subtitle: "Geben Sie Ihre E-Mail-Adresse oder Telefonnummer ein und rechnen Sie los. Wir melden uns nur, wenn Sie es möchten.",
        name: "Name (optional)",
        email: "E-Mail-Adresse",
        phone: "Telefonnummer",
        or: "oder",
        cta: "Preisrechner öffnen",
        error: "Bitte geben Sie mindestens eine Kontaktmöglichkeit an (E-Mail oder Telefon).",
        emailError: "Diese E-Mail-Adresse scheint ungültig zu sein.",
      },
      fancoil: {
        label: "Haben Sie ein Fan-Coil- oder Deckengerät?",
        body: "Es erfordert eine spezielle Demontage, daher erstellen wir ein individuelles Angebot.",
        cta: "Individuelles Angebot anfragen",
        page: {
          title: "Fan Coil & Deckengeräte – individuelles Angebot",
          lead: "Die Reinigung von Fan-Coil- und Decken-(Kassetten-)Geräten erfordert eine spezielle Demontage, daher können wir keinen Listenpreis anbieten – wir erstellen immer ein individuelles Angebot.",
          points: [
            "Die Demontage von Gehäuse und Kondensatwanne ist je nach Modell unterschiedlich",
            "Oft sind Leiter- oder Gerüstarbeiten erforderlich",
            "Der Preis hängt vom Einbauort und der Zugänglichkeit ab",
          ],
          how: "Fordern Sie ein Angebot an – senden Sie nach Möglichkeit ein Foto des Geräts, und wir nennen Ihnen innerhalb von 24 Stunden einen genauen Preis:",
          callCta: "Anrufen",
          waCta: "Anfrage per WhatsApp",
          emailCta: "E-Mail senden",
          waMsg: "Hallo! Ich möchte ein individuelles Angebot für die Reinigung eines Fan-Coil- / Deckengeräts anfragen.",
          back: "Zurück zur Startseite",
        },
      },
    },
    faq: {
      label: "FAQ",
      title: "Häufige Fragen",
      items: [
        { q: "Was kostet die Klimareinigung?", a: "Erstes Innengerät 21.000 Ft – deutlicher Rabatt auf jedes weitere Gerät. Den genauen Preis liefert unser Online-Rechner." },
        { q: "Wie oft sollte man die Klimaanlage reinigen lassen?", a: "Mindestens einmal jährlich, idealerweise vor dem Sommer. Staub, Feuchtigkeit und Pollen am Balaton machen es besonders wichtig." },
        { q: "Wie lange dauert die Reinigung?", a: "In der Regel 60–90 Minuten pro Gerät, mit abschließendem Leistungstest." },
        { q: "Welche Gebiete decken Sie ab?", a: "Balatonszemes und das Südufer des Balaton: Siófok, Balatonföldvár, Balatonszárszó, Balatonlelle, Balatonboglár, Fonyód und Umgebung. Über 15 km fallen 5.000 Ft Anfahrtskosten an." },
        { q: "Warum riecht meine Klimaanlage muffig?", a: "Pilze und Bakterien am Wärmetauscher sind die Ursache. Unsere Ozon- und Antipilzbehandlung beseitigt die Ursache, nicht nur den Geruch." },
      ],
    },
  },
  nl: {
    nav: {
      services: "Diensten",
      about: "Over ons",
      process: "Werkwijze",
      booking: "Afspraak",
      contact: "Contact",
      bookNow: "Afspraak maken",
    },
    hero: {
      eyebrow: "Balatonszemes · Airco-reiniging",
      titleA: "Frissere",
      titleB: "lucht",
      titleC: "aan het Balatonmeer.",
      subtitle:
        "A-team biedt professionele airco-reiniging voor woningen en vakantiehuizen in en rond Balatonszemes. Gezondere lucht, efficiëntere koeling en een langere levensduur van uw apparaat.",
      ctaPrimary: "Afspraak maken",
      ctaSecondary: "Bel ons nu",
      cardTitle: "Professionele reiniging",
      cardSub: "60–90 min / apparaat",
      stats: [
        { value: "100%", label: "Lokaal team" },
        { value: "24u", label: "Terugbeltijd" },
        { value: "5★", label: "Klantbeoordeling" },
      ],
    },
    services: {
      label: "Diensten",
      title: "Zo ziet een echte airco-reiniging eruit",
      subtitle:
        "Meer dan alleen afstoffen. Een grondige dieptereiniging die de oorspronkelijke prestaties van uw airco herstelt.",
      items: [
        {
          title: "Filterwas & desinfectie",
          body: "We verwijderen, wassen en behandelen de filters met een antibacteriële oplossing.",
        },
        {
          title: "Warmtewisselaar dieptereiniging",
          body: "Schuimtechnologie verwijdert aanslag – de unit koelt weer efficiënt.",
        },
        {
          title: "Schimmel- en geurbehandeling",
          body: "Ozon- en antischimmelbehandeling tegen vervelende geuren en schimmelsporen.",
        },
        {
          title: "Controle buitenunit",
          body: "Condensor wassen, controle van aansluitingen en condensafvoer.",
        },
        {
          title: "Prestatietest",
          body: "We meten de in-/uitlaattemperatuur, geluidsniveau en stroomverbruik.",
        },
      ],
    },
    about: {
      label: "Over ons",
      title: "Een lokaal team. Eén missie.",
      body1:
        "A-team is een kleine onderneming gevestigd in Balatonszemes, gericht op één ding: het reinigen van airco's. Wij installeren of repareren niet – wij reinigen, grondig, elke keer.",
      body2:
        "We kennen de omgeving aan het meer: zomerstof, vochtigheid, pollen en de omstandigheden aan de oever verminderen samen de prestaties van airco's. Een jaarlijkse reiniging lost dit op.",
      bullets: [
        "Eigen professionele apparatuur",
        "Documentatie & garantie na elke reiniging",
        "Klantenservice in het Hongaars, Engels, Duits & Nederlands",
      ],
      locationCaption: "zuidkust · Hongarije",
    },
    process: {
      label: "Werkwijze",
      title: "Drie eenvoudige stappen",
      steps: [
        {
          n: "01",
          title: "Online boeken",
          body: "Kies een datum, type airco en aantal units – slechts enkele klikken.",
        },
        {
          n: "02",
          title: "Telefonische bevestiging",
          body: "We bellen u binnen 24 uur terug om de details te bevestigen.",
        },
        {
          n: "03",
          title: "Reiniging ter plaatse",
          body: "Meestal 60–90 minuten per unit. Frisse lucht, efficiënte koeling.",
        },
      ],
    },
    booking: {
      label: "Afspraak",
      title: "Maak uw afspraak",
      subtitle:
        "Vul het formulier in. We bellen u binnen 24 uur terug ter bevestiging.",
      step: "Stap",
      of: "van",
      next: "Volgende",
      back: "Terug",
      submit: "Boeking verzenden",
      submitting: "Verzenden…",
      fields: {
        name: "Volledige naam",
        phone: "Telefoon",
        email: "E-mail",
        address: "Adres (straat, nr., plaats)",
        acType: "Type airco",
        units: "Aantal units",
        date: "Gewenste datum",
        time: "Tijdstip",
        notes: "Opmerkingen (optioneel)",
        notesPh: "Bijv. in welke kamers airco's hangen, parkeren, toegang…",
      },
      acTypes: {
        split: "Split (1 binnenunit)",
        multi_split: "Multi-split (meerdere binnenunits)",
        cassette: "Cassette / plafond",
        portable: "Mobiele airco",
        other: "Anders",
      },
      times: {
        morning: "Ochtend (8–11)",
        midday: "Middag (11–14)",
        afternoon: "Namiddag (14–17)",
        evening: "Avond (17–20)",
      },
      steps: {
        s1: "Contact",
        s2: "Locatie & airco",
        s3: "Datum & tijd",
      },
      success: {
        title: "Bedankt voor uw boeking!",
        body: "Uw boeking is ontvangen. We bellen u binnen 24 uur terug ter bevestiging.",
        ref: "Boekingsreferentie",
        cta: "Nieuwe boeking",
      },
      errors: {
        required: "Verplicht veld",
        email: "Ongeldig e-mailadres",
        phone: "Voer een geldig telefoonnummer in",
        server: "Er is iets misgegaan. Probeer het opnieuw.",
        consent: "Accepteer de mededeling om uw boeking af te ronden.",
      },
      consentLabel:
        "Ik begrijp dat airco-reiniging geen reparatie is: bij een bestaand mechanisch of elektronisch defect kan de reiniging niet worden uitgevoerd.",
      terms: {
        pre: "Ik accepteer de ",
        aszfLink: "Algemene Voorwaarden",
        mid: " en het ",
        gdprLink: "Privacybeleid",
        post: ".",
        error: "Accepteer de Algemene Voorwaarden en het Privacybeleid om uw boeking af te ronden.",
      },
    },
    contact: {
      label: "Contact",
      title: "Laten we praten – makkelijker dan u denkt",
      phone: "Telefoon",
      email: "E-mail",
      area: "Werkgebied",
      areaValue: "Balatonszemes en 25 km in de omtrek",
      hours: "Openingstijden",
      hoursValue: "Ma–Za: 8:00 – 19:00",
    },
    footer: {
      tag: "Airco-reiniging in Balatonszemes",
      rights: "Alle rechten voorbehouden.",
      built: "Gemaakt door een lokaal team aan de oever van het Balatonmeer.",
    },
    marquee: [
      "Gezondere lucht",
      "Lager stroomverbruik",
      "Langere levensduur",
      "Allergeenvrij huis",
      "Geurvrije lucht",
    ],
    review: {
      label: "Beoordelingen",
      title: "Tevreden? Vertel het bij Google!",
      body: "Een beoordeling van 30 seconden is enorm waardevol voor een klein lokaal bedrijf. Bedankt dat u even de tijd neemt!",
      cta: "Beoordeel ons op Google",
      subnote: "Opent in een nieuw tabblad · log in met uw Google-account",
    },
    showcase: {
      title: "Zo werken wij",
      subtitle: "Een korte blik achter de schermen bij onze airco-reiniging – live.",
      play: "Video afspelen",
      duration: "22 seconden · met geluid",
      noSupport: "Uw browser ondersteunt video-afspelen niet.",
    },
    testimonials: {
      title: "Wat onze klanten zeggen",
    },
    whatsapp: {
      label: "WhatsApp",
      title: "Stuur ons een WhatsApp",
      value: "Snel antwoord, foto's welkom",
      cta: "Stuur een bericht",
      floating: "Chat",
      prefilled:
        "Hallo! Ik ben geïnteresseerd in airco-reiniging in Balatonszemes. Kunt u mij een afspraak geven?",
    },
    notice: {
      label: "Belangrijke mededeling",
      title: "Reiniging is geen reparatie",
      greeting: "Beste klant,",
      p1: "Wij willen u graag wijzen op het fundamentele verschil tussen onderhoud en reparatie. Het doel van airco-reiniging is het verwijderen van opgehoopt stof, schimmels en bacteriën, en het waarborgen van een hygiënische werking en energie-efficiëntie.",
      p2: "Bij de reiniging worden geen onderdelen vervangen, wordt geen koudemiddel bijgevuld en worden geen elektrische reparaties uitgevoerd. Als uw airco een bestaand mechanisch of elektronisch defect heeft (bijv. printplaatstoring, compressordefect, koudemiddellek), blijft deze ook na de reiniging defect.",
      p3: "Onze collega's schakelen het apparaat vóór aanvang van het werk altijd in en controleren het. Als de airco al bij het opstarten een storing vertoont, kunnen wij de reiniging pas uitvoeren nadat het defect is verholpen.",
    },
    calculator: {
      label: "Prijscalculator",
      title: "Bereken direct de prijs",
      subtitle: "Stel het aantal apparaten in en zie meteen de exacte prijs – geen verborgen kosten.",
      indoor: "Binnenunits",
      indoorHint: "Eerste unit 21.000 Ft, elke volgende 15.000 Ft",
      outdoor: "Buitenunits",
      outdoorHint: "4.000 Ft per stuk",
      high: "Waarvan boven 3 m gemonteerd",
      highHint: "6.500 Ft in plaats van 4.000 Ft",
      far: "Ik ben meer dan 15 km van Balatonszemes",
      farHint: "+5.000 Ft voorrijkosten",
      breakdown: {
        firstIndoor: "Eerste binnenunit",
        extraIndoor: "Extra binnenunit",
        outdoorStd: "Buitenunit",
        outdoorHigh: "Buitenunit (boven 3 m)",
        travel: "Voorrijkosten (boven 15 km)",
      },
      total: "Totaal",
      cta: "Boek voor deze prijs",
      prefillNote: "Via de prijscalculator: {indoor} binnenunit(s), {outdoor} buitenunit(s) – berekende prijs: {total}",
      note: "De prijs omvat de volledige dieptereiniging, desinfectie en de prestatietest.",
      gate: {
        title: "Eén stap naar de calculator",
        subtitle: "Vul uw e-mailadres of telefoonnummer in en bereken direct. Wij nemen alleen contact op als u dat wilt.",
        name: "Naam (optioneel)",
        email: "E-mailadres",
        phone: "Telefoonnummer",
        or: "of",
        cta: "Calculator openen",
        error: "Vul minimaal één contactgegeven in (e-mail of telefoon).",
        emailError: "Dit e-mailadres lijkt ongeldig.",
      },
      fancoil: {
        label: "Heeft u een fan coil of plafondunit?",
        body: "Deze vereist speciale demontage, daarom maken wij een offerte op maat.",
        cta: "Offerte op maat aanvragen",
        page: {
          title: "Fan coil & plafondunits – offerte op maat",
          lead: "Het reinigen van fan coil- en plafond-(cassette-)units vereist speciale demontage, daarom kunnen wij geen vaste prijs geven – wij maken altijd een offerte op maat.",
          points: [
            "De demontage van behuizing en lekbak verschilt per model",
            "Vaak is ladder- of steigerwerk nodig",
            "De prijs hangt af van de locatie en bereikbaarheid van de unit",
          ],
          how: "Vraag een offerte aan – stuur indien mogelijk een foto van het apparaat en wij geven binnen 24 uur een exacte prijs:",
          callCta: "Bel ons",
          waCta: "Aanvragen via WhatsApp",
          emailCta: "E-mail sturen",
          waMsg: "Hallo! Ik wil graag een offerte op maat aanvragen voor het reinigen van een fan coil / plafondunit.",
          back: "Terug naar de homepage",
        },
      },
    },
    faq: {
      label: "FAQ",
      title: "Veelgestelde vragen",
      items: [
        { q: "Wat kost airco-reiniging?", a: "Eerste binnenunit 21.000 Ft – flinke korting op elke volgende unit. Bereken de exacte prijs met onze online calculator." },
        { q: "Hoe vaak moet een airco gereinigd worden?", a: "Minstens één keer per jaar, het liefst vóór de zomer. Stof, vocht en pollen aan het Balatonmeer maken het extra belangrijk." },
        { q: "Hoe lang duurt de reiniging?", a: "Meestal 60–90 minuten per unit, afgesloten met een prestatietest." },
        { q: "Welke gebieden dekken jullie?", a: "Balatonszemes en de zuidoever van het Balatonmeer: Siófok, Balatonföldvár, Balatonszárszó, Balatonlelle, Balatonboglár, Fonyód en omgeving. Boven 15 km geldt 5.000 Ft voorrijkosten." },
        { q: "Waarom ruikt mijn airco muf?", a: "Schimmels en bacteriën op de warmtewisselaar zijn de oorzaak. Onze ozon- en antischimmelbehandeling pakt de oorzaak aan, niet alleen de geur." },
      ],
    },
  },
};

export const COMPANY = {
  name: "A-team",
  email: "a.ugyfelek@icloud.com",
  phone: "+36 70 577 8151",
  phoneIntl: "+36705778151",
  whatsappPhone: "36705778151",
  town: "Balatonszemes",
  googleReviewUrl: "https://g.page/r/CRoLIj0VwaDXEAE/review",
  videoUrl:
    "https://customer-assets.emergentagent.com/job_ac-service-balaton/artifacts/uzu7fjea_copy_FB6C875A-9898-4FAD-9719-33A4504FADAC.MOV",
};

export function buildWhatsAppUrl(message) {
  const text = encodeURIComponent(message);
  return `https://wa.me/${COMPANY.whatsappPhone}?text=${text}`;
}
